import $axios from '../services/api.js'
import cookie from 'vue-cookie'

const state = () => ({
    kahzanahBab: [],
    kahzanahBabDetail: [],
    page: 0,
    prev_page_url : null,
    next_page_url : null,
    khazanahBabBoorkmark: []
})

const mutations = {
    ASSIGN_DATA_BAB(state, payload) {
        state.kahzanahBab = payload
    },
    ASSIGN_DATA_BAB_DETAIL(state, payload) {
        state.kahzanahBabDetail = payload
    },
    SET_PAGE(state, payload) {
        state.page = payload
    },
    SET_PREV_PAGE(state, payload) {
        state.prev_page_url = payload
    },
    SET_NEXT_PAGE(state, payload) {
        state.next_page_url = payload
    },
    SET_BOORKMARK(state, payload) {
        state.khazanahBabBoorkmark = payload
    }
}

const actions = {
    getKhazanahBookmarkBab({ commit }) {
        let token =  cookie.get('token')
        if (token) {
            return new Promise((resolve) => {
                $axios.get(`api/bookmark/khazanah`)
                    .then((response) => {
                        let temp_bookmark = []
                        response.data.data.forEach(element => {
                            if (!temp_bookmark.includes(element.post_id)) {
                                temp_bookmark.push(element.post_id)
                            }

                            // temp_bookmark[element.post_id].push(element.page)
                        })

                        response.data.data.forEach(element => {
                            temp_bookmark[element.post_id].push(element.page)
                        })
                        console.log(temp_bookmark)
                        
                        commit('SET_BOOKMARK', [])
                        // commit('ASSIGN_DATA_BAB', response.data.data)
                        resolve(response.data)
                    })
            })
        }
    },
    getKhazanahBab({ commit }, payload) {
        return new Promise((resolve) => {
            $axios.get(`api/khazanah/bab/${payload}`)
                .then((response) => {
                    commit('ASSIGN_DATA_BAB', response.data.data)
                    resolve(response.data)
                })
        })
    },
    getKhazanahBabDetail({ commit }, payload) {
        return new Promise((resolve) => {
            $axios.get(`api/khazanah/bab/detail/${payload}`)
                .then((response) => {
                    commit('ASSIGN_DATA_BAB_DETAIL', response.data.data.data)

                    commit('SET_PAGE', response.data.data.current_page)
                    commit('SET_NEXT_PAGE', response.data.data.next_page_url)
                    commit('SET_PREV_PAGE', response.data.data.prev_page_url)

                    resolve(response.data)
                })
        })
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}